import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "conversion-options"
    }}>{`Conversion Options`}</h1>
    <p>{`Objects for specifying save options and conversion options for various file formats using `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#saveas"
      }}>{`Document.saveAs`}</a>{` and `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#changemode"
      }}>{`Document.changeMode`}</a>{`, respectively`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      